import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    addNotifications(state, action) {
      // Remove any existing notification with the same key
      return [
        ...state.filter(({ key }) => key !== action.payload?.key),
        action.payload,
      ];
    },
    hideNotifications(state, action) {
      // Remove notifications with keys included in the payload
      return state.filter(({ key }) => !action.payload.includes(key));
    },
  },
});

export const { addNotifications, hideNotifications } =
  notificationsSlice.actions;

export default notificationsSlice.reducer;
